export default function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Embedded Termly Content */}
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="bg-white rounded-lg shadow-sm overflow-hidden">
          <iframe
            src="https://app.termly.io/policy-viewer/policy.html?policyUUID=7c04dd3d-7bc2-47ae-be67-e5b122900cf7#toc"
            className="w-full border-0"
            style={{ minHeight: '100vh' }}
            title="Privacy Policy"
            sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
          />
        </div>
      </div>
    </div>
  )
}
